module.exports = __webpack_public_path__ + "static/media/editIcon.fc6f2b03.svg";